<template>
    <div>
        <section class="page-content center">
            <br>
            <v-layout row wrap>    
                <v-flex xs12 sm12 lg12>
                    <p class="total" style="font-size:25px" v-if="confirmado">{{msmTitulo}}</p>
                    <p class="total" style="color:#D64550; font-size:25px" v-else>{{msmTitulo}}</p>    
                    <v-container class="resumo">
                        <p style="font-size:18px" v-if="this.company.reteveAdesao == true">{{msgCorpoAdesao}}</p>
                        <p style="font-size:18px" v-else>{{msgCorpo}}</p>
                    </v-container>
                </v-flex>
                <v-flex xs12 sm12 md12 lg8 v-if="pdfSelecionado!=''">
                    <p class="total">Minutas, Manuais e Guias</p>
                    <iframe v-if="this.$vuetify.breakpoint.lg" :src="`${pdfSelecionado}`" width="680" height="400" style="border: none;"></iframe>
                </v-flex>
                <v-flex xs12 sm12 md12 lg4>
                    <br>
                    <br>
                    <div v-if="this.$vuetify.breakpoint.lg">
                        <v-list-tile
                            v-if="planoSelecionado.urlContrato != '' && planoSelecionado.urlContrato != undefined"
                            @click="pdfSelecionado = planoSelecionado.urlContrato" avatar
                        >
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Contrato</v-list-tile-title>
                        </v-list-tile>
                    </div>
                    <div v-else>
                        <v-list-tile
                            v-if="planoSelecionado.urlMinutaContrato != '' && planoSelecionado.urlMinutaContrato != undefined"
                            @click="pdfSelecionado = planoSelecionado.urlMinutaContrato" :href="planoSelecionado.urlMinutaContrato" target='_blank' avatar
                        >
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Minuta do Contrato</v-list-tile-title>
                        </v-list-tile>
                    </div>

                    <div v-if="this.$vuetify.breakpoint.lg">
                        <v-list-tile
                            v-if="planoSelecionado.urlMinutaAditivo != '' && planoSelecionado.urlMinutaAditivo != undefined"
                            @click="pdfSelecionado = planoSelecionado.urlMinutaAditivo" avatar
                        >
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Minuta do Aditivo</v-list-tile-title>
                        </v-list-tile>
                    </div>
                    <div v-else>
                        <v-list-tile
                            v-if="planoSelecionado.urlMinutaAditivo != '' && planoSelecionado.urlMinutaAditivo != undefined"
                            @click="pdfSelecionado = planoSelecionado.urlMinutaAditivo" :href="planoSelecionado.urlMinutaAditivo" target='_blank' avatar
                        >
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Minuta do Aditivo</v-list-tile-title>
                        </v-list-tile>
                    </div>

                    <div v-if="this.$vuetify.breakpoint.lg">
                        <v-list-tile
                            v-if="planoSelecionado.urlCobertura != '' && planoSelecionado.urlCobertura != undefined"
                            @click="pdfSelecionado = planoSelecionado.urlCobertura" avatar
                        >
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Cobertura do Plano</v-list-tile-title>
                        </v-list-tile>
                    </div>
                    <div v-else>
                        <v-list-tile
                            v-if="planoSelecionado.urlCobertura != '' && planoSelecionado.urlCobertura != undefined"
                            @click="pdfSelecionado = planoSelecionado.urlCobertura" :href="planoSelecionado.urlCobertura" target='_blank' avatar
                        >
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Cobertura do Plano</v-list-tile-title>
                        </v-list-tile>
                    </div>

                    <div v-if="this.$vuetify.breakpoint.lg">
                        <v-list-tile
                            v-if="planoSelecionado.urlManual != '' && planoSelecionado.urlManual != undefined"
                            @click="pdfSelecionado = planoSelecionado.urlManual" avatar
                        >
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Manual de Orientação</v-list-tile-title>
                        </v-list-tile>
                    </div>
                    <div v-else>
                        <v-list-tile
                            v-if="planoSelecionado.urlManual != '' && planoSelecionado.urlManual != undefined"
                            @click="pdfSelecionado = planoSelecionado.urlManual" :href="planoSelecionado.urlManual" target='_blank' avatar
                        >
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Manual de Orientação</v-list-tile-title>
                        </v-list-tile>
                    </div>

                    <div v-if="this.$vuetify.breakpoint.lg">
                        <v-list-tile
                            v-if="planoSelecionado.urlGuia != '' && planoSelecionado.urlGuia != undefined"
                            @click="pdfSelecionado = planoSelecionado.urlGuia" avatar
                        >
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Guia de Leitura Contratual</v-list-tile-title>
                        </v-list-tile>
                    </div>
                    <div v-else>
                        <v-list-tile
                            v-if="planoSelecionado.urlGuia != '' && planoSelecionado.urlGuia != undefined"
                            @click="pdfSelecionado = planoSelecionado.urlGuia" :href="planoSelecionado.urlGuia" target='_blank' avatar
                        >
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Guia de Leitura Contratual</v-list-tile-title>
                        </v-list-tile>
                    </div>
                </v-flex>
                <v-flex xs12 sm12 lg4 v-if="this.company.status != 'AGUARDANDO CONFIRMAÇÃO'">
                    <div class="planos-wrapper" style="background:none">
                        <div class="list-planos">                    
                            <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Plano Empresarial</h6>
                                <br>
                                <p class="price"><span>R$</span> {{company.responsibility}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Proposta com status: {{this.company.status}}</h6>
                            </div>
                        </div>
                    </div>
                </v-flex>

                <v-flex xs12 sm12 lg12 v-else>
                    <v-flex xs12 sm12 lg4 v-if="this.company.reteveAdesao == true">
                        <v-flex xs12 sm3 md12 lg12>
                            <v-checkbox v-model="contrataccept" color="#8395A7">
                                <span slot="label">Li e concordo com os termos do contrato</span>
                            </v-checkbox>
                        </v-flex>
                        <div class="planos-wrapper" style="background:none">
                            <div class="list-planos">                    
                                <div class="item">
                                    <h6 class="form-titulo" style="text-align: center;">Plano Empresarial</h6>
                                    <br>
                                    <p class="price"><span>R$</span> {{company.responsibility}}<br></p>
                                    <br>
                                    <h6 class="desconto" style="text-align: center;">Adesão</h6>
                                    <a @click="aceiteProposta()" class="button">Aceitar Proposta</a>
                                </div>
                            </div>
                        </div>
                    </v-flex>

                    <v-flex xs12 sm12 lg4 v-else>
                        <v-flex xs12 sm3 md12 lg12>
                            <v-checkbox v-model="contrataccept" color="#8395A7">
                                <span slot="label">Li e concordo com os termos do contrato</span>
                            </v-checkbox>
                        </v-flex>
                        <div class="planos-wrapper" style="background:none">
                            <div class="list-planos">                    
                                <div class="item">
                                    <h6 class="form-titulo" style="text-align: center;">Plano Empresarial</h6>
                                    <br>
                                    <p class="price"><span>R$</span> {{company.responsibility}}<br></p>
                                    <br>
                                    <h6 class="desconto" style="text-align: center;">Adesão</h6>
                                    <a @click="gerarBoletoEG()" class="button">Gerar Boleto</a>
                                </div>
                            </div>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="imprimir">
                        <div class="planos-wrapper" style="background:none">
                            <div class="list-planos">                    
                                <div class="item">
                                    <h6 class="form-titulo" style="text-align: center;">Plano Empresarial</h6>
                                    <br>
                                    <p class="price"><span>R$</span> {{company.responsibility}}<br></p>
                                    <br>
                                    <h6 class="desconto" style="text-align: center;">Adesão</h6>
                                    <a @click="imprimirBoleto()" class="button">Imprimir Boleto</a>
                                </div>
                            </div>
                        </div>
                    </v-flex>
                </v-flex>
            </v-layout>
            <br>
            <br>
            <br>
            <br> 
        </section>

        <!-- Diálogo do Boleto -->
        <v-dialog v-model="dialogoBoleto" persistent max-width="500px">
            <v-card>
                <v-card-text style="padding-bottom: 0px">
                    <p style="color: #229A00; text-align: center; font-size: 20px; font-weight: bold">{{ responseBoleto.Valor }}</p>
                    <v-container grid-list-md style="padding: 10px">
                        <v-layout row wrap>
                            <v-flex>
                                <p style="font-size: 14px; font-weight: bold">Você tem até o dia {{ responseBoleto.Vencimento.substring(0, 5) }} para pagar</p>
                                <p style="font-size: 12px; margin-top: 5px; line-height: 14px; text-align: justify">Para pagar pelo Internet Banking, copie a linha digitável. Para pagar em qualquer banco, caixa eletrônico ou lotérica, por favor, imprima o boleto.</p>
                                <p style="font-size: 12px; font-weight: bold; margin-top: 10px; line-height: 14px; text-align: justify">Se o pagamento é feito de segunda a sexta, é creditado no dia seguinte. Se você pagar no fim de semana, será creditado na terça-feira.</p>
                            </v-flex>
                            <v-flex>
                                <p style="font-size: 12px; text-align: center; margin-top: 10px; font-weight: bold">{{ responseBoleto.LinhaDigitavel }}</p>
                                <v-text-field id="linhaDigitavel" v-model="responseBoleto.LinhaDigitavel" readonly style="padding: 1px; position: absolute; left: -99999px;"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12>
                                <v-btn block color="primary" @click="doCopy('linhaDigitavel', 'Linha digitável copiada!')">
                                    <v-icon left>mdi-content-copy</v-icon>Copiar linha digitável
                                </v-btn>
                                <v-btn block color="primary" @click="imprimirBoletoEG(responseBoleto.BoletoID)" :loading="impressaoBoleto">
                                    <v-icon left>print</v-icon>Imprimir boleto
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="red" @click="confirmaContrato()">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <loading :active.sync="isLoading" :can-cancel="true" color="#7593b4" :is-full-page="fullPage"></loading>
        <Snackbar ref=chamaSnackbar />
    </div>
</template>

<script>
    import Snackbar from '../components/snackbar.vue'
    import axios from 'axios'
    // Import component
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { baseApiUrl, modelBoleto, operadora, } from '@/global'
    export default {
        components: {Snackbar, Loading},
        data() {
            return {
                msmTitulo: 'Estamos quase lá!',
                msgCorpo: 'Para concluir a sua proposta, é necessário gerar o boleto. Para isso, basta clicar no botão abaixo e aguardar.' ,
                msgCorpoAdesao: 'Para concluir a sua proposta, é necessário concordar com os termos do contrato e aceitar no botão abaixo.' ,
                confirmado: true,
                company: [],
                boletoGerado: false,
                pdfSelecionado: '',
                planoSelecionado: '',
                contrataccept: false,
                cidade: '',
                estado: '',
                bairro: '',
                fullPage: true,  
                isLoading: false, 
                token: '',
                idBoleto: '', 
                ipConfirm: '',
                imprimir: false,
                // Propriedades do diálogo do boleto
                dialogoBoleto: false,
                responseBoleto: {
                    BoletoID: '',
                    LinhaDigitavel: '',
                    Valor: '',
                    Vencimento: '',
                },
                impressaoBoleto: false,
            }               
        },

        mounted : function() {
            localStorage.clear()
            sessionStorage.clear()
            this.pegaParametrosUrl()
            this.carregaPlano()
        },

        methods: {
            async carregaPlano() {
                try {
                    let res = await axios.get(`${baseApiUrl}PrecoPlanos?filter={"where":{"companyId":"${this.company.id}"},"include":"plans"}`)
                    if (res.data != '') {
                        this.planoSelecionado = res.data[0].plans
                        this.pdfSelecionado = res.data[0].plans.urlMinutaContrato 
                    }
                } catch (error) {
                    this.isLoading = false
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao carregar plano", "ERRO");
                }
            },

            async pegaIPeData() {
                await axios.get(`https://api.ipify.org/?format=json`)
                .then(res => {
                    if (res.data) {
                        this.company.companyIPConfirm = res.data.ip
                    }
                })
                .catch(() => {
                    this.company.companyIPConfirm = '127.0.0.0'
                })

                this.company.companyConfirm = new Date().toISOString()
            },

            async gerarBoleto() {
                var vm = this
                if (this.contrataccept) {
                    this.company.proposalNumber = this.company.id.replace(/[^\d]+/g,'').substr(0, 8)+Math.floor(10 + Math.random() * 10)
                    this.isLoading = true
                    this.token = ''
                    this.idBoleto = ''            
                    //Criando data de vencimeto do boleto
                    var datapagvenc = new Date();
                    datapagvenc.setDate(new Date().getDate() + 3)
                    //Preencher o campos do model de Boleto
                    modelBoleto.pagadorDocumentoNumero = this.company.cnpj.replace(/[^\d]+/g,'')
                    modelBoleto.pagadorNome = this.company.businessName.substr(0, 39)
                    modelBoleto.pagadorEndereco = this.company.address.substr(0, 39) + ', ' + this.company.addressNumber
                    modelBoleto.pagadorBairro = this.bairro.substr(0, 19)
                    modelBoleto.pagadorDocumentoTipo = 2
                    modelBoleto.pagadorCidade = this.cidade.substr(0, 19)
                    modelBoleto.pagadorUf = this.estado 
                    modelBoleto.pagadorCep = this.company.cep.replace(/[^\d]+/g,'');
                    modelBoleto.dataVencimento = datapagvenc.toISOString().substr(0, 10)
                    modelBoleto.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
                    //salvando o responsibility e o valor do boleto caso seja anual
                    modelBoleto.valorNominal = parseFloat(this.company.responsibility)
                    modelBoleto.mensagem = 'Boleto referente ao plano empresarial'        
                    modelBoleto.nsu = this.company.proposalNumber
                    modelBoleto.nossoNumero = parseInt(this.company.proposalNumber +Math.floor(10 + Math.random() * 99))
                    modelBoleto.seuNumero = this.company.proposalNumber +Math.floor(10 + Math.random() * 99)
          
                    //Gerando o Boleto e pegando o ID
                    try {
                        let res = await axios.post(baseApiUrl + 'Pagamentos/boletosPost', modelBoleto)
                        if (res.data != '') {
                            this.idBoleto = res.data.id
                            this.imprimirBoleto()
                        }
                    } catch (error) {
                        this.isLoading = false
                        vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar Boleto, tente novamente!","ERRO");
                        this.close()
                    }
                } else {
                    this.isLoading = false
                    vm.$refs.chamaSnackbar.snack("#F9A825","Para gerar o boleto, é necessário concordar com os termos do contrato!","ATENÇÃO");
                }
            },

            async gerarBoletoEG() {
                var vm = this
                if (this.contrataccept) {
                    this.isLoading = true
                    this.token = ''
                    this.company.formOfPayment = this.planoSelecionado.typePayment
                    if (!this.company.proposalNumber) {
                        this.company.proposalNumber = this.company.id.replace(/[^\d]+/g,'').substr(0, 8)+Math.floor(10 + Math.random() * 10)
                    }
                    await this.pegaIPeData()

                    await axios.post(`${baseApiUrl}Companies/atualizarPublico`, {"id": this.company.id, "data": this.company});

                    // Criando data de vencimeto do boleto
                    var datapagvenc = new Date();
                    datapagvenc.setDate(new Date().getDate() + 3)

                    let dadosBoleto = {
                        "Numero": this.encrypt(this.company.proposalNumber.toString()),
                        "MeiosPagamentos": [
                            {
                                "TipoTransacao": 10,
                                "NumeroParcelas": 1,
                                "DataPrimeiraParcela": datapagvenc.toISOString().substring(0, 10)
                            }
                        ],
                        "ItensVendidos": [
                            {
                                "Descricao": "Referente ao plano empresarial - Proposta de Número: " + this.company.proposalNumber
                            }
                        ],
                        "Cliente": {
                            "Documento": this.company.cnpj.replace(/[^\d]+/g,''),
                            "Endereco": this.company.address + ', ' + this.company.addressNumber,
                            "UF": this.estado,
                            "Cidade": this.cidade,
                            "Bairro": this.bairro,
                            "Cep": this.company.cep.replace(/[^\d]+/g,''),
                            "Nome": this.company.businessName
                        }
                    }
                    
                    //Gerando o Boleto e pegando o ID
                    try {
                        let res = await axios.post(baseApiUrl + 'Pagamentos/boletosPostEG', dadosBoleto)
                        if (res.data) {
                            this.idBoleto = res.data.BoletoID
                            this.responseBoleto = {
                                BoletoID: res.data.BoletoID,
                                LinhaDigitavel: res.data.LinhaDigitavel,
                                Valor: res.data.Valor,
                                Vencimento: res.data.Vencimento,
                            };
                            this.dialogoBoleto = true;
                            this.isLoading = false;
                        } else {
                            this.isLoading = false
                            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar Boleto: Resposta inválida do servidor.","ERRO");
                        }
                    } catch (error) {
                        this.isLoading = false
                        vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar Boleto, tente novamente!","ERRO");
                    }
                } else {
                    this.isLoading = false
                    vm.$refs.chamaSnackbar.snack("#F9A825","Para gerar o boleto, é necessário concordar com os termos do contrato!","ATENÇÃO");
                }
            },

            async imprimirBoletoEG(boletoId) {
                this.impressaoBoleto = true
                try {
                    let response = await axios.post(baseApiUrl + 'Pagamentos/pdfBoletoEG', {"boletoId": boletoId})
                    if (response.data.url) {
                        this.impressaoBoleto = false
                        window.open(response.data.url)
                    }
                } catch (error) {
                    this.impressaoBoleto = false
                    this.$refs.chamaSnackbar.snack("#F9A825","Problema ao imprimir boleto. Tente novamente!","DESCULPE");
                }
            },

            async aceiteProposta() {
                if (this.contrataccept) {
                    await this.pegaDadosConfirmacao()
                    try {
                        this.isLoading = true
                        let envio = {
                            "salesmanIPConfirm": this.ipConfirm,
                            "companyIPConfirm": this.ipConfirm,
                            "salesmanConfirm": this.confirmDate,
                            "companyConfirm": this.confirmDate,
                            "status": "EM PROCESSAMENTO"
                        }
                        await axios.post(`${baseApiUrl}Companies/atualizarPublico`, {"id": this.company.id, "data": envio})
                        .then(() => {
                            this.isLoading = false
                            vm = this;
                            vm.$refs.chamaSnackbar.snack("#51D400","Com a confirmação dos dados da empresa, bem como dos colaboradores, após o pagamento do boleto, fica autorizado à Odontobase a dar andamento na proposta ao Contrato Coletivo Empresarial.","Proposta confirmada com Sucesso!") 
                        }).catch(() => {
                            var vm = this;
                            vm.$refs.chamaSnackbar.snack("#F9A825","Você pode tentar confirmar novamente ou entrar em contato com a Odontobase.","Algo deu errado na confirmação da proposta!")
                        })
                    } catch (error) {
                        var vm = this;
                        vm.$refs.chamaSnackbar.snack("#F9A825","Erro ao aceitar proposta. Por favor, tente novamente","ATENÇÃO")
                    }
                } else {
                    this.isLoading = false
                    vm = this;
                    vm.$refs.chamaSnackbar.snack("#F9A825","Para aceitar a proposta, é necessário concordar com os termos do contrato!","ATENÇÃO");
                }
            },
        
            async imprimirBoleto() {
                this.isLoading = true
                await this.pegaDadosConfirmacao()
                //Baixando Boleto PDF
                try {
                    let res = await axios.get(`https://p4x.srv.br/api/v1.0/boletos/${this.idBoleto}/imprimir`,{ responseType: 'arraybuffer', headers: {
                            Authorization: 'Bearer ' + this.token, //the token is a variable which holds the token
                            'Content-type': 'application/pdf'
                        }
                    })
                    if (res.data != null) {
                        //Create a Blob from the PDF Stream
                        const file = new Blob(
                            [res.data], 
                            {type: 'application/pdf'}
                        );
                        //Build a URL from the file
                        const fileURL = URL.createObjectURL(file);
                        const link = document.createElement('a');
                        link.href = fileURL;
                        link.setAttribute('download', 'boleto.pdf'); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                        //Open the URL on new Window
                        window.open(fileURL);
                        if (!this.boletoGerado) {
                            this.boletoGerado = true
                            this.msmTitulo = 'Proposta confirmada com Sucesso!'
                            this.msgCorpo = 'Com a confirmação dos dados da empresa, bem como dos colaboradores, após o pagamento do boleto, fica autorizado à ' + operadora.nome + ' a dar andamento na proposta ao Contrato Coletivo Empresarial.'
                            this.atualizaCompany()
                        } else {
                            this.imprimir = false
                            this.msmTitulo = 'Boleto impresso com Sucesso!'
                            this.msgCorpo = 'Com a confirmação dos dados da empresa, bem como dos colaboradores, após o pagamento do boleto, fica autorizado à ' + operadora.nome + ' a dar andamento na proposta ao Contrato Coletivo Empresarial.'  
                        }
                        this.isLoading = false 
                    }              
                } catch (error) {
                    this.isLoading = false
                    var vm = this;            
                    vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao imprimir boleto. Tente novamente ou entre em contato com a " + operadora.nome + "!","DESCULPE");
                    this.close()                 
                }
            },

            async pegaParametrosUrl() {
                var params = window.location.search.substring(1).split('?');
                if (params[0] != '') {
                    //Criar objeto que vai conter os parametros
                    var paramArray = {};
                    //Passar por todos os parametros
                    for (var i=0; i<params.length; i++) {
                        //Dividir os parametros chave e valor
                        var param = params[i].split('=');
                        //Adicionar ao objeto criado antes
                        paramArray[param[0]] = param[1];
                    }
                    if (paramArray['cp']) {   
                        await axios.get(`${baseApiUrl}Companies/getPublico?id=${paramArray['cp']}`)
                        .then(res => { 
                            if (res.data != null) {
                                this.company = res.data[0]
                                if (this.company.situacaoBoleto == "" || this.company.situacaoBoleto == "VENCIDO" || this.company.situacaoBoleto == undefined) { 
                                    this.retornoViaCEP()
                                    this.confirmado = true 
                                } else if(this.company.situacaoBoleto == "PAGO") {
                                    this.confirmado = true
                                    this.boletoGerado = true
                                    this.msmTitulo = 'Pagamento detectado!'
                                    this.msgCorpo = 'Olá, detectamos que você já efetuou o pagamento do boleto, entre em contato com a Odontobase para mais informações.'
                                } else if(this.company.situacaoBoleto == "BAIXADO") {
                                    this.confirmado = true
                                    this.boletoGerado = true
                                    this.msmTitulo = 'Boleto Baixado!'
                                    this.msgCorpo = 'Olá, O boleto para essa proposta encontra-se baixado, para mais informações entre em contato com a Odontobase.'
                                } else if(this.company.situacaoBoleto == "REGISTRADO" || this.company.situacaoBoleto == "GERADO") {
                                    this.msmTitulo = 'Boleto disponível!'
                                    this.msgCorpo = 'Olá, já existe um boleto gerado para a sua proposta, clique abaixo para imprimir.'
                                    this.confirmado = true
                                    this.imprimir = true
                                    this.boletoGerado = true
                                    this.idBoleto = this.company.boletoId
                                    //this.imprimirBoleto()
                                }
                            }
                            this.carregaPlano()
                        }).catch(() => {
                            this.confirmado = false
                            this.msmTitulo = 'Algo deu errado na confirmação da proposta!'
                            this.msgCorpo = 'Você pode tentar confirmar novamente ou entrar em contato com a Odontobase.'
                        })
                    }
                }
            },

            async atualizaCompany() {
              let envio = {
                "salesmanIPConfirm": this.ipConfirm,
                "companyIPConfirm": this.ipConfirm,
                "salesmanConfirm": this.confirmDate,
                "companyConfirm": this.confirmDate,
                "boletoId": this.idBoleto,
                "situacaoBoleto": "GERADO",
                "nossoNumero": modelBoleto.nossoNumero,
                "status": "AGUARDANDO PAGAMENTO"
              }
                try {
                    await axios.post(`${baseApiUrl}Companies/atualizarPublico`, {"id": this.company.id, "data": envio})
                } catch (error) {
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#F9A825","Erro ao atualizar situação do boleto, tente novamente","ATENÇÃO")                   
                }
            },

            async retornoViaCEP() {
                if (this.company.cep != '') {
                    try {
                        let res = await axios.get(`https://viacep.com.br/ws/${this.company.cep.replace(/[^\d]+/g,'')}/json/`) 
                        if (res.data != '') {
                            this.cidade = res.data.localidade
                            this.estado = res.data.uf
                            this.bairro = res.data.bairro.normalize("NFD").replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9 ]/g, '')
                            if (!this.cidade || !this.estado || !this.bairro)
                                this.retornoCEP()
                        } else {
                            var vmcep = this;
                            vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                            this.cidade = ''
                            this.estado = ''
                            this.bairro = ''
                        }
                    } catch (error) {
                        vmcep = this;
                        vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                        this.cidade = ''
                        this.estado = ''
                        this.bairro = ''
                    }
                }
            },

            async retornoCEP() {
                try {
                    let res = await axios.post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : this.company.cep}) 
                    if (res.data != '') {
                        await axios.get(`${baseApiUrl}UFs?filter={"where":{"codeS4":${res.data.IdUf}}}`).then(res2 => {
                            this.estado = res2.data[0].prefix
                            this.cidade = res.data.Municipio
                            this.bairro = res.data.Bairro
                        })
                    }
                } catch (error) {
                    var vmcep = this;
                    vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                }
            },

            //Função para criptografia
            encrypt(text) {
                let crypto = require('crypto');
                let password = 'pxuelh2so839ljis';
                let iv = 'pxuelh2so839ljis';
                let cipher = crypto.createCipheriv('aes-128-cbc', password, iv);
                let encryptedData = cipher.update(text, 'utf8', 'Base64') + cipher.final('Base64');

                return encryptedData;
            },

            // Métodos do diálogo do boleto
            doCopy(elementId, message) {
                try {
                    const element = document.getElementById(elementId);
                    element.select();
                    document.execCommand('copy');
                    this.$refs.chamaSnackbar.snack('success', message, 'SUCESSO');
                } catch (e) {
                    this.$refs.chamaSnackbar.snack('error', 'Não foi possível copiar.', 'ERRO');
                }
            },

            confirmaContrato() {
                this.dialogoBoleto = false;
                // Adicione aqui qualquer lógica adicional necessária após fechar o diálogo
            },

            async pegaDadosConfirmacao() {
            //coleta IP, data e hora da confirmação do cliente    
                try {
                    let res = await axios.get(`https://api.ipify.org/?format=json`)
                    if (res.data != null) {
                      this.ipConfirm = res.data.ip
                    } else {
                      this.ipConfirm = '127.0.0.0'
                    }
                } catch (error) {
                    this.ipConfirm = '127.0.0.0'
                }
                this.confirmDate = new Date().toISOString()
            },
        }
    }
</script>

<style>
    .link {
        font-size: 1.3rem;
        color: #194383;
        text-align: center;
    }

    .titulo {
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }

    .imagemcaarj {
        background: url('https://www.apvs.com.br/assets/uploads/parceiros/caarj.png')no-repeat;
        background-size: 500px;
    }
</style>
